import useUIContext from '~/ui/use-ui-context.ts';

const useContextContainer = () => {
	const { contextRef } = useUIContext();
	return contextRef?.current;
};

export default useContextContainer;
